import { AddressDataValues } from '../models/addressDataValues';
import { ApiResponse, ProfileResponseData } from '../models/apiResponse';
import { Recipient } from '../models/parcelDeliveryMiles';
import { PersonalDataValues } from '../models/personalDataValues';
import { PreferencesDataValues } from '../models/preferencesDataValues';
import { Phone } from '../models/user';
import { apiRequests as requests } from './http-client';

const Profile = {
  profile: () =>
    requests
      .get<ApiResponse<ProfileResponseData>>('/v1/profile')
      .then((authResponse) => authResponse.data?.user),
  updatePreferences: (preferences: PreferencesDataValues) =>
    requests
      .post<
        ApiResponse<ProfileResponseData>
      >('/v1/profile/update-user-location', preferences)
      .then((authResponse) => authResponse.data?.user),
  updatePersonalData: (personalData: PersonalDataValues) =>
    requests
      .post<
        ApiResponse<ProfileResponseData>
      >('/v1/profile/update-personal-data', personalData)
      .then((authResponse) => authResponse.data?.user),
  updateAddress: (addressInfo: AddressDataValues) =>
    requests
      .post<
        ApiResponse<ProfileResponseData>
      >('/v1/profile/update-user-address', addressInfo)
      .then((authResponse) => authResponse.data?.user),
  updatePassword: (password: string) =>
    requests
      .post<ApiResponse<ProfileResponseData>>('/v1/profile/update-password', {
        password,
        confirm_password: password,
      })
      .then((authResponse) => authResponse.data?.user),

  verifyPhone: (phoneCountryCode: string, phoneNumber: string, code: string) =>
    requests
      .post<ApiResponse>('/v1/profile/verify-phone', {
        phone_country_code: phoneCountryCode,
        phone: phoneNumber,
        code,
      })
      .then((authResponse) => authResponse.data),
  updatePhone: (phone: Phone | null) =>
    requests.post<ApiResponse>('/v1/profile/update-phone', {
      phone_country_code: phone?.country_code,
      phone: phone?.phone_number,
    }),
  receivers: (query: string) =>
    requests
      .get<ApiResponse<Recipient[]>>(`/v1/receivers?${query}`)
      .then((authResponse) => authResponse),
  getReceiver: (id: number) =>
    requests
      .get<
        ApiResponse<{ name: string; value: string | number | null }[]>
      >(`/v1/receivers/${id}`)
      .then((authResponse) => authResponse),
  migrate: (shouldMigrate: boolean) =>
    requests.post('/v1/profile/migration-response', {
      migrate_user_data: shouldMigrate,
    }),
  getSenderAddresses: () =>
    requests
      .get<ApiResponse<AddressDataValues[]>>(`/v1/profile/senders`)
      .then((authResponse) => authResponse.data),
  createSenderAddress: (address: AddressDataValues) =>
    requests
      .post<ApiResponse<AddressDataValues>>('/v1/profile/senders', address)
      .then((authResponse) => authResponse.data),
  updateSenderAddress: (address: AddressDataValues) =>
    requests
      .put<
        ApiResponse<AddressDataValues>
      >(`/v1/profile/senders/${address.id}`, address)
      .then((authResponse) => authResponse.data),
  deleteSenderAddress: (id: number) =>
    requests
      .del<ApiResponse>(`/v1/profile/senders/${id}`)
      .then((authResponse) => authResponse),
};

export default Profile;
